import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./components/sidebar";
import Anuncios from "./views/Anuncios";
import Eventos from "./views/Eventos";
import Miembros from "./views/Miembros";
import "./dashboard.css";

export default function Dashboard() {
  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboardContent">
        <Routes>
          <Route path="/" element={<Anuncios />} />
          <Route path="eventos" element={<Eventos />} />
          <Route path="miembros" element={<Miembros />} />
        </Routes>
      </div>
    </div>
  );
}
